"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.sort.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.array.map.js");
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _icon = _interopRequireDefault(require("@digital-hig/icon"));
var _utility = require("@digital-hig/icon/lib/build/icons/utility");
var _core = require("@lingui/core");
var _react = require("@lingui/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ProductsCovered = function ProductsCovered(_ref) {
  var products = _ref.products,
    open = _ref.open;
  var _useState = (0, _react2.useState)(open),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    showProducts = _useState2[0],
    setShowProducts = _useState2[1];
  var productColumnLength = Math.ceil(products.length / 4);
  var originalProductList = products.sort(function (a, b) {
    return a.localeCompare(b);
  });
  var columnedProductList = [];
  var i;
  var len;
  for (i = 0, len = originalProductList.length; i < len; i += productColumnLength) {
    columnedProductList.push({
      id: i,
      products: originalProductList.slice(i, i + productColumnLength)
    });
  }
  return /*#__PURE__*/_react2.default.createElement(_react.I18nProvider, {
    i18n: _core.i18n
  }, products && products.length > 0 ? /*#__PURE__*/_react2.default.createElement(Wrapper, {
    onClick: function onClick() {
      return setShowProducts(!showProducts);
    },
    className: "dhig-mt-2 dhig-pt-2 dhig-pb-2",
    "data-testid": "show-products"
  }, /*#__PURE__*/_react2.default.createElement("p", {
    className: "MuiTypography-root MuiTypography-headline-smaller dhig-typography dhig-typography-headline-smaller"
  }, /*#__PURE__*/_react2.default.createElement(_react.Trans, {
    id: "Products and versions covered"
  }), /*#__PURE__*/_react2.default.createElement(AttributionCaret, null, /*#__PURE__*/_react2.default.createElement("span", {
    className: "caret-icon",
    "data-testid": "show-products-caret"
  }, /*#__PURE__*/_react2.default.createElement(_icon.default, null, showProducts ? /*#__PURE__*/_react2.default.createElement(_utility.CaretUp, null) : /*#__PURE__*/_react2.default.createElement(_utility.CaretDown, null)))))) : null, /*#__PURE__*/_react2.default.createElement(Divider, null), showProducts ? /*#__PURE__*/_react2.default.createElement("div", null, /*#__PURE__*/_react2.default.createElement("span", {
    className: "dhig-typography dhig-typography-headline-smallest"
  }, /*#__PURE__*/_react2.default.createElement("div", {
    className: "row dhig-flex dhig-flex-wrap dhig-pb-3",
    "data-testid": "show-products-list"
  }, columnedProductList.map(function (column) {
    return /*#__PURE__*/_react2.default.createElement("div", {
      key: column.id,
      className: "col dhig-w-full md:dhig-w-1/2 lg:dhig-w-1/4 dhig-pb-4 etx-covered-product-name"
    }, column.products.map(function (product) {
      return /*#__PURE__*/_react2.default.createElement("div", {
        key: "key_".concat(product)
      }, /*#__PURE__*/_react2.default.createElement("span", {
        className: "MuiTypography-root MuiTypography-headline-smallest dhig-typography dhig-typography-headline-smallest"
      }, product));
    }));
  })))) : null);
};
var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "ProductsCovered__Wrapper",
  componentId: "ha-__sc-1figngr-0"
})(["display:flex;cursor:pointer;"]);
var Divider = _styledComponents.default.div.withConfig({
  displayName: "ProductsCovered__Divider",
  componentId: "ha-__sc-1figngr-1"
})(["width:100% !important;clear:both;height:10px;"]);
var AttributionCaret = _styledComponents.default.div.withConfig({
  displayName: "ProductsCovered__AttributionCaret",
  componentId: "ha-__sc-1figngr-2"
})(["color:#212121;margin-left:4px;width:16px;height:16px;float:right;"]);
ProductsCovered.propTypes = {
  /**
   * Product list in either string or string array
   */
  products: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
  open: _propTypes.default.bool
};
ProductsCovered.defaultProps = {
  products: [],
  open: false
};
var _default = ProductsCovered;
exports.default = _default;